import { Events, Event } from './content';

// Note: Order-only. We keep all events and just sort by date.

export const TokyoEatLikeALocalEvents: Events = {
  events: ([] as Event[]).sort((a, b) => a.date.localeCompare(b.date))
};

export const pagesEvents: Record<string, Events> = {
  'tokyo-local-food-experiences': TokyoEatLikeALocalEvents,
  // Add other pages as needed
};
